import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";


import additionalInfoPageStyle from "assets/jss/prehnit/views/additionalInfoPageStyle.jsx"

import { linksOrganizations as LinksFallback } from "config/LinksList";

import { withNamespaces } from "react-i18next";

import { API } from "services/api";

class SectionLinksOrganizations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      links: []
    }

    let links = [];
    API.getContentLinksByGroup('organisations')
    .then (data => {
      if (data && data.length > 0) {
        links = data;
      } else {
        console.warn('Loading Fallback Links...!');
        links = LinksFallback;
      }

      this.setState({
        links: links
      })
    });
  }

  render() {
    const { t, classes } = this.props;
    return (
      <div className="cd-section" >
        <div className={classes.container}>
          {/* Feature 2 START */}
          <div className={classes.features2}>
            <GridContainer>
              <GridItem
                xs={12}
                sm={8}
                md={8}
                className={`${classes.mlAuto} ${classes.mrAuto} ${
                  classes.textCenter
                }`}
              >
                <h2 className={classes.title}>{t("pagecontent:info-heading2")}</h2>
                <h5 className={classes.description}>{t("pagecontent:info-content2")}</h5>
              </GridItem>
            </GridContainer>
            <GridContainer>
              {this.state.links.map((link, id) => {
                return (
                  <GridItem xs={12} sm={4} md={4} key={id}>
                  <InfoArea
                      icon={link.icon ? link.icon : "link"}
                      title={link.title_trans_token ? t(link.title_trans_token) : link.title}
                      description={
                        <span>
                          <p>{link.dsc_trans_token ? t(link.dsc_trans_token) : link.desc}</p>
                          <a href={link.url} target="_blank" className={classes.block}>
                            {t("find-more")}...
                          </a>
                        </span>
                      }
                      iconColor={link.icon_color ? link.icon_color : "info"}
                    />
                  </GridItem>
                );
              })}

            </GridContainer>
          </div>
        </div>

      </div>
    );
  }
}

export default withNamespaces()(withStyles(additionalInfoPageStyle)(SectionLinksOrganizations));
